import React from 'react';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DashboardMain from './Dashboard/Main';
import Sidebar from './Sidebar/Sidebar';
import Login from './Login/Login';
import UseAuth from './Login/UseAuth';
import User from './User';
import WebPlayback from './Player/Webplayback';
import HistoryAnalysis from './NowPlaying/HistoryAnalysis';
import CurrentlyPlaying from './NowPlaying/CurrentlyPlaying';
import { setCurrentUser } from './Redux/currentUser';
import { setReduxAccessToken } from "./Redux/accessToken";

const code = new URLSearchParams(window.location.search).get('code');

function App() {
  const accessToken = sessionStorage.getItem('accessToken') || UseAuth(code);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const currentTrack = useSelector((state) => state.currentTrack);
  const currentUser = useSelector((state) => state.currentUser);
  const dispatch = useDispatch();
  const [weeklyScore, setWeeklyScore] = useState(null);
  const [tokenExpired, setTokenExpired] = useState(true);

    useEffect(() => {
    // Define function to check if access token is expired
    const isTokenExpired = () => {
      const expirationTime = localStorage.getItem('expiresIn');
      const now = new Date().getTime();
      setTokenExpired(now >= expirationTime)
      return now >= expirationTime;
    };

    // If access token is expired, refresh it
    const refreshAccessToken = async () => {
      try {
        const response = await axios.post(baseUrl + 'refresh', { refreshToken: localStorage.getItem('refreshToken') });
        console.log(localStorage.getItem('refreshToken'));
        setReduxAccessToken(response.data.access_token);
        localStorage.setItem('accessToken', response.data.access_token);
        dispatch(setReduxAccessToken(response.data.accessToken));
        localStorage.setItem('expiresIn', response.data.expires_in);
      } catch (err) {
        console.error('Could not refresh token: ', err);
      }
    };

    // Check if access token is expired, and if so, refresh it
    if (isTokenExpired()) {
      refreshAccessToken();
    }
  }, [baseUrl, dispatch]);

    useEffect(() => {
      if (accessToken && !tokenExpired) {
        dispatch(setReduxAccessToken(accessToken));
      }
    }, [accessToken ,tokenExpired, dispatch]);

      // Get user info
  useEffect(() => {
    try {
      if (accessToken && !tokenExpired) {
        const getUser = async () => {
          const response = await axios({
            method: 'post',
            url: baseUrl + 'user',
            data: {
              accessToken: accessToken,
            },
          })
            console.log(response.data);
            dispatch(setCurrentUser(response.data));
        }
        getUser();
      }
    } catch (err) {
      window.alert('Could not get user: ', err)
    }
  }, [accessToken, tokenExpired, dispatch]);

  // Get recently played tracks
  useEffect(() => {
    try {
      if (accessToken && !tokenExpired && currentUser) {
        const getHistory = async () => {
          const response = await axios({
            method: 'post',
            url: baseUrl + 'get-history',
            data: {
              accessToken: accessToken,
              currentUser: currentUser
            },
          })
          setWeeklyScore(response.data);
        }
        getHistory()
      }
    } catch (err) {
      console.log(err);
    }
  }, [accessToken, currentUser, tokenExpired]);

  return (
    <div>
      {accessToken ? (
        <div id='index'>
          <User />
          <Sidebar weeklyScore={weeklyScore} />
          <DashboardMain />
          {currentTrack?.title.length > 0 ? (
            <CurrentlyPlaying currentTrack={currentTrack} />
          ) : weeklyScore ? (
            <HistoryAnalysis />
          ) : <div style={{height: '90%', width: '30%', background: '#000000'}}/>}
          <WebPlayback />
        </div>
      ) : (
        <Login />
      )}
    </div>
  );
}

export default App;
